import { forwardRef, type ComponentProps, type ReactNode } from 'react'
import { PreviewCard as BasePreviewCard } from '@base-ui/react/preview-card'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

export interface TriggerProps extends PartProps<ComponentProps<typeof BasePreviewCard.Trigger>> {
  className?: string
  icon?: ReactNode
  /** Drop the inline-link styling, for a trigger that is its own element (a pill, a card). */
  unstyled?: boolean
}

export const Trigger = forwardRef<HTMLAnchorElement, TriggerProps>(function Trigger(
  { className, icon, unstyled, delay = 400, children, ...props },
  ref,
) {
  return (
    <BasePreviewCard.Trigger
      ref={ref}
      delay={delay}
      className={
        unstyled
          ? className
          : twMerge(
              'text-foreground-secondary hover:text-foreground group/trigger corner-smooth relative inline h-4 text-nowrap rounded-md font-medium no-underline outline-none transition-colors hover:no-underline',
              '[&_svg]:size-4',
              'focus-visible:corner-smooth focus-visible:rounded-sm focus-visible:no-underline',
              'data-[popup-open]:no-underline data-[popup-open]:focus-visible:no-underline',
              className,
            )
      }
      {...props}
    >
      {icon && (
        <span className="relative inline-block h-[18px] w-5 align-middle">
          <span className="absolute">{icon}</span>
        </span>
      )}
      {children}
    </BasePreviewCard.Trigger>
  )
})
